import { IUserInvoice } from 'server/models/UserInvoice';
import { IUser } from 'server/models/User';
import { IReduxAction } from 'types/IReduxAction';
import { InvoicesDashboardTypes } from 'dashboard/_redux/types/invoicesDashboardTypes';
import { PaginatedResponse } from 'types/Posts';

export interface IUserWithInvoiceData {
  _id: string;
  username: string;
  email: string;
  avatar?: string;
  totalTransactions: number;
  totalAmount: number;
  lastTransaction: string;
  totalInvoices: number;
}

export interface IInvoicesDashboardState {
  usersWithInvoices: PaginatedResponse<IUserWithInvoiceData>;
  selectedUser: IUser | null;
  selectedUserInvoices: IUserInvoice[];
  loaded: boolean;
}

const emptyPagination: PaginatedResponse<IUserWithInvoiceData> = {
  items: [],
  totalItems: 0,
  page: 1,
  hasNextPage: false,
};

const initialState: IInvoicesDashboardState = {
  usersWithInvoices: emptyPagination,
  selectedUser: null,
  selectedUserInvoices: [],
  loaded: false,
};

export default (
  state = initialState,
  { type, payload }: IReduxAction,
): IInvoicesDashboardState => {
  switch (type) {
    case InvoicesDashboardTypes.FETCH_USERS_WITH_INVOICES_START:
      return { ...state, loaded: false };
    case InvoicesDashboardTypes.FETCH_USERS_WITH_INVOICES_SUCCESS:
      return { ...state, usersWithInvoices: payload, loaded: true };
    case InvoicesDashboardTypes.FETCH_USERS_WITH_INVOICES_FAILURE:
      return { ...state, loaded: true };
    case InvoicesDashboardTypes.FETCH_USER_INVOICES_START:
      return { ...state, loaded: false };
    case InvoicesDashboardTypes.FETCH_USER_INVOICES_SUCCESS:
      return {
        ...state,
        selectedUser: payload.user,
        selectedUserInvoices: payload.invoices,
        loaded: true,
      };
    case InvoicesDashboardTypes.FETCH_USER_INVOICES_FAILURE:
      return { ...state, loaded: true };
    default:
      return state;
  }
};
